import { useEffect, useState } from "react";
import { GraduationCap, Mail } from "lucide-react";
import { EMAIL } from "../../data/content";

const LINKS = [
    { label: "About", href: "#about" },
    { label: "Tutors", href: "#tutors" },
    { label: "Method", href: "#method" },
    { label: "Reviews", href: "#reviews" },
    { label: "Pricing", href: "#pricing" },
    { label: "Availability", href: "#availability" },
];

export const Nav = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (e, href) => {
        e.preventDefault();
        if (window.__lenis) window.__lenis.scrollTo(href, { offset: -70 });
        else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <header
            data-testid="site-nav"
            className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 border-b ${
                scrolled
                    ? "bg-bone/85 backdrop-blur-xl hairline"
                    : "bg-transparent border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
                <a
                    href="#top"
                    onClick={(e) => go(e, "#top")}
                    data-testid="nav-logo-link"
                    className="flex items-center gap-2.5"
                >
                    <GraduationCap className="w-5 h-5 text-navy" strokeWidth={1.75} />
                    <span className="font-serif text-lg font-semibold tracking-tight text-ink">
                        North Shore Scholars
                    </span>
                </a>
                <nav className="hidden lg:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={(e) => go(e, l.href)}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate2 hover:text-oxblood transition-colors duration-300"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <a
                    href="#contact"
                    onClick={(e) => go(e, "#contact")}
                    data-testid="nav-email-button"
                    className="hidden sm:inline-flex items-center gap-2 border border-ink/20 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.15em] text-ink hover:bg-ink hover:text-bone transition-colors duration-300"
                >
                    <Mail className="w-3.5 h-3.5" strokeWidth={1.75} />
                    Enquire
                </a>
            </div>
        </header>
    );
};
